import type { ConstantsMap } from "./options"
import { buildOptionsFromConstantsMap } from "./options"

const TRANSACTION_METHODS_MAP = {
  PosCard: {
    value: "pos_card",
    label: "Card",
  },
  PosCash: {
    value: "pos_cash",
    label: "Cash",
  },
} as const satisfies ConstantsMap

const _options = buildOptionsFromConstantsMap(
  TRANSACTION_METHODS_MAP
)
export type TransactionMethod =
  (typeof TRANSACTION_METHODS_MAP)[keyof typeof TRANSACTION_METHODS_MAP]["value"]

export const useTransactionMethodOptions = () => ({
  options: _options,
  getLabelForValue: (value: TransactionMethod) =>
    computed(
      () =>
        _options.find((option) => option.value === value)
          ?.label || ""
    ),
})
